import { IKnowledgeBaseService } from '@agent/core/knowledge-base/knowledge-base.service';
import { Component, Inject, Input, OnChanges, OnDestroy } from '@angular/core';
import { NG1_KNOWLEDGE_BASE } from '@commons/core/core.provider.ajs';

import { UntilDestroy } from '@contact/upgrade';

const KNOWLEDGE_BASE_FRAME_CONTAINER_NAME = 'agentKnowledgeBaseContainer';

@UntilDestroy()
@Component({
  selector: 'owi-iframe',
  templateUrl: 'owi-iframe.component.html',
  styleUrls: ['./owi-iframe.component.scss'],
})
export class OwiIframeComponent implements OnChanges, OnDestroy {
  @Input() readonly show: boolean;

  constructor(@Inject(NG1_KNOWLEDGE_BASE) private readonly knowledgeBaseService: IKnowledgeBaseService) {}

  ngOnChanges(): void {
    if (this.show) {
      const container = document.getElementById(KNOWLEDGE_BASE_FRAME_CONTAINER_NAME);
      if (container) {
        this.knowledgeBaseService.showFrame(container);
      }
    } else {
      this.knowledgeBaseService.hideFrame();
    }
  }

  ngOnDestroy(): void {
    this.knowledgeBaseService.hideFrame();
  }
}
